<template>

  <div>
    <div>
      <div style="margin-bottom: 10px; position: relative; z-index: 1">
        <el-input
            v-model="getAllTicketAppRequest.nameTicket"
            style="width: 300px"
            placeholder="Nhập tên gói"
            @clear="searchHeaderMethodTicket()"
            clearable
            @keyup.enter.native="searchHeaderMethodTicket()"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="searchHeaderMethodTicket()"
            ></el-button>
          </template>
        </el-input>
      </div>

    </div>

    <div>
      <el-table
          ref="multipleTable"
          :empty-text="textTableTemplateAppTab"
          v-loading="loadingDataTicket"
          :element-loading-text="$tableLoading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255, 0)"
          highlight-current-row
          :data="ticketAppList"
          :header-cell-style="tableHeaderColor"
          @selection-change="handleSelectionChangeTicket"
          :max-height="$tableMaxHeight"
          border
      >
        <el-table-column
            type="selection"
            align="center"
            fixed
            width="80"
        ></el-table-column>
        <el-table-column
            fixed
            type="index"
            label="STT"
            width="80"
            align="center"
        ></el-table-column>
        <el-table-column
            label="Tên gói"
            min-width="200"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.id }} - {{ scope.row.nameTicket }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Mô tả gói"
            min-width="300"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.descriptionTicket }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="Nguồn"
            width="200"
            align="center"
        >
          <template v-slot:default="scope">
            <span>{{ formatTypeTicket(scope.row.typeTicket) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="Phiên bản"
            min-width="150"
            align="center"
        >
          <template v-slot:default="scope">
            <span>{{ scope.row.version }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Mặc định hệ thống" width="150" align="center">
          <template v-slot:default="scope">
            <el-checkbox
                @change="setDefaultTemplate(scope.row)"
                v-model="scope.row.defaultTicket"
            ></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column
            fixed="right"
            label="Tác vụ"
            width="300"
            align="center"
        >
          <template v-slot:default="scope">
            <el-button
                size="mini"
                type="success"
                @click="openDetailTicketAppDialog(scope.row)"
            >Chi tiết
            </el-button>
            <el-button
                :disabled="scope.row.typeTicket === 'system'"
                size="mini"
                type="primary"
                @click="openUpdateTicketAppDialog(scope.row)"
            >Sửa
            </el-button
            >
            <el-button
                size="mini"
                type="danger"
                @click="deleteTemplateAppMethod(scope.row)"
            >Xóa
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 15px">
        <el-col :span="9" :offset="11">
          <el-pagination
              background
              style=" margin-right: 5.2rem;margin-left: auto"
              @size-change="handleSizeChangeTemplate"
              @current-change="handleCurrentChangeTemplate"
              :current-page.sync="currentPagePagination"
              :page-sizes="$pageListDefaultNew"
              :page-size="sizeLimit"
              layout="prev, pager,sizes, next"
              :total="sizeLimit * totalPages"
          ></el-pagination>
        </el-col>
        <el-col :span="2" :offset="2" style="display: inline-flex;justify-content: right">
          <el-dropdown @command="handleActionTemplate">
            <el-button class="button-over" type="success">
              Tác vụ
              <i class="el-icon-caret-bottom"/>
            </el-button>
            <el-dropdown-menu>
              <el-dropdown-item command="addTemplate"
              >Thêm phiếu bé ngoan
              </el-dropdown-item
              >
              <el-dropdown-item command="deleteManyTemplate"
              >Xoá phiếu bé ngoan
              </el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>

      <DetailTicketAppDialogMasterSchool
          :isOpenDetailTicketAppDialog="showDetailTicketAppDialog"
          @dialog-close="closeDetailTicketAppDialog()"
          ref="DetailTicketAppDialog"
      ></DetailTicketAppDialogMasterSchool>

      <UpdateTicketAppDialogMasterSchool
          :isOpenUpdateTicketAppDialog="showUpdateTicketAppDialog"
          @dialog-close="closeUpdateTicketAppDialog()"
          ref="UpdateTicketAppDialog"
      ></UpdateTicketAppDialogMasterSchool>


      <AddTicketAppDialogMasterSchool
          :isOpenAddTicketAppDialog="showAddTemplateAppDialog"
          @dialog-close="closeAddTemplateAppDialog()"
          ref="AddTemplateAppDialog"
      ></AddTicketAppDialogMasterSchool>

    </div>
  </div>


</template>


<script>
import AddTicketAppDialogMasterSchool
  from "@/views/master/school/templateApp/dialog/AddTicketAppDialogMasterSchool.vue";
import UpdateTicketAppDialogMasterSchool
  from "@/views/master/school/templateApp/dialog/UpdateTicketAppDialogMasterSchool.vue";
import DetailTicketAppDialogMasterSchool
  from "@/views/master/school/templateApp/dialog/DetailTicketAppDialogMasterSchool.vue";
import TicketService from "@/services/TicketService";

export default {
  components: {
    DetailTicketAppDialogMasterSchool,
    UpdateTicketAppDialogMasterSchool,
    AddTicketAppDialogMasterSchool,
  },
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      sizeLimit: 10,
      totalPages: 0,
      currentPagePagination: 1,
      showDetailTicketAppDialog: false,
      showUpdateTicketAppDialog: false,
      showAddTemplateAppDialog: false,
      textTableTemplateAppTab: "Không có dữ liệu!",
      layout: "sizes, prev, pager, next",
      getAllTicketAppRequest: {
        nameTicket: "",
        pageNumber: 1,
        pageTotal: this.$pageTotalDefault,
        maxPageItem: 10,
      },
      ticketAppList: [],
      showSearchIconAppTemplate: false,
      multipleSelectionTicket: [],
      loadingDataTicket: true,
    }

  },
  created() {
    this.searchHeaderMethodTicket();
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    openDetailTicketAppDialog(row) {
      this.showDetailTicketAppDialog = true;
      this.$refs.DetailTicketAppDialog.getDataInitialDetailTicketAppDialog(row);
    },

    closeDetailTicketAppDialog() {
      this.showDetailTicketAppDialog = false;
    },
    openAddTemplateAppDialog() {
      this.showAddTemplateAppDialog = true;
    },

    closeAddTemplateAppDialog() {
      this.showAddTemplateAppDialog = false;
      this.getAllDataForTicketAppTab();
    },

    openUpdateTicketAppDialog(row) {
      this.showUpdateTicketAppDialog = true;
      this.$refs.UpdateTicketAppDialog.getDataInitialUpdateTicketDialog(row);
    },

    closeUpdateTicketAppDialog() {
      this.showUpdateTicketAppDialog = false;
      this.getAllDataForTicketAppTab();
    },


    handleActionTemplate(command) {
      if (command === "addTemplate") {
        this.openAddTemplateAppDialog();
      } else if (command === "deleteManyTemplate") {
        this.deleteOneOrManyTemplate()
      }
    },
    handleSelectionChangeTicket(val) {
      this.multipleSelectionTicket = val;
    },

    getAllDataForTicketAppTab() {
      this.loadingDataTicket = true;
      let nameTicket = this.getAllTicketAppRequest.nameTicket;
      let pageNumber = this.getAllTicketAppRequest.pageNumber;
      let maxPageItem = this.getAllTicketAppRequest.maxPageItem;
      TicketService.getListTicketMasterSchool(nameTicket, pageNumber, maxPageItem)
          .then((resp) => {
            this.ticketAppList = resp.data.data.listTicket;
            this.loadingDataTicket = false;
            this.totalPages = Math.floor(resp.data.data.total / this.sizeLimit);
            if ((resp.data.data.total % this.sizeLimit) !== 0) {
              this.totalPages = this.totalPages + 1
            }
          })
          .catch((err) => {
            this.pageTotal = 1;
            this.ticketAppList = [];
            this.loadingDataTicket = false;
            console.log(err);
          })
          .finally(() => {
            if (this.ticketAppList.length === 0) {
              this.textTableTemplateAppTab = this.$tableEmpty;
            }
            this.loadingDataTicket = false;
          });
    },

    handleSizeChangeTemplate(value) {
      this.sizeLimit = value;
      this.getAllTicketAppRequest.maxPageItem = value;
      this.getAllTicketAppRequest.pageNumber = 1;
      this.getAllDataForTicketAppTab();
    },

    handleCurrentChangeTemplate(value) {
      this.currentPagePagination = value
      this.getAllTicketAppRequest.pageNumber = value;
      this.getAllDataForTicketAppTab();
    },
    searchHeaderMethodTicket() {
      this.pageNumber = 1;
      this.getAllDataForTicketAppTab();
    },

    /**
     * Xoá 1 template
     */
    deleteTemplateAppMethod(row) {
      let idTicket = row.id
      this.$confirm(`Xác nhận xóa "${row.nameTicket}" ?`, 'Cảnh báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
        type: 'warning'
      }).then(() => {
        TicketService.deleteTicketMasterSchool(idTicket)
            .then((res) => {
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.getAllDataForTicketAppTab()
              this.closeDialog()
            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy thao tác'
        });
      });
    },

    /**
     * Xoá 1 hoặc nhiều Template
     */
    deleteOneOrManyTemplate() {
      let idTicketList = this.multipleSelectionTicket.map(x => x.id);
      this.checkSelectBeforeHandleFunction(idTicketList);
      this.$confirm('Xác nhận xóa các phiếu bé ngoan đã chọn ?', 'Cảnh báo', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ bỏ',
        type: 'warning'
      }).then(() => {
        TicketService.deleteMultiTicketMasterSchool(idTicketList)
            .then((res) => {
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.getAllDataForTicketAppTab()
              this.closeDialog()
            })
            .catch((err) => {
              console.log(err.message);

            })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy thao tác'
        });
      });
    },

    checkSelectBeforeHandleFunction() {
      let selectRowList = this.multipleSelectionTicket.map((x) => x.id);
      if (selectRowList.length === 0) {
        this.$message({
          message: "Bạn chưa chọn gói nào",
          type: "error",
        });
        throw null;
      }
    },

    setDefaultTemplate(row) {
      let idTicket = row.id
      this.loadingDataTicket = true;
      TicketService.setDefaultTicketMasterSchool(idTicket)
          .then((resp) => {
            this.$message({
              message: resp.data.message,
              type: "success",
            });
            this.getAllDataForTicketAppTab()
          })
          .catch((err) => {
            this.$message({
              message: err.response.data.message,
              type: "error",
            });
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingDataTicket = false;
            }, 500);
          });
    },

    formatTypeTicket(type) {
      switch (type) {
        case "school":
          return "Nhà trường";
        case "system":
          return "Hệ thống";
      }
    }
  },
  beforeMount() {

    this.getAllDataForTemplateAppTab();

  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table td,
/deep/ .el-table th {
  padding: 10px 0;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

/deep/ .el-table .cell {
  white-space: pre-line;
  line-height: 20px;
  word-break: break-word;
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 3px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

  // display: inline-block;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

// .table-header {
//   position: sticky;
// }
// table{

// }
thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  // height: 600px;
  font-family: Arial, Helvetica, sans-serif;
  // display: block;
  // width: 90%;
}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.button-left-class_search {
  margin-right: 5px;
  width: 150px;
}
</style>